import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { ArrowLeft } from 'lucide-react';

const TERMS = [
  'The content of the pages of this website is subject to change without notice.',
  'Neither we nor any third parties provide any warranty or guarantee as to the accuracy, timeliness, performance, completeness or suitability of the information and materials found or offered on this website for any particular purpose. You acknowledge that such information and materials may contain inaccuracies or errors and we expressly exclude liability for any such inaccuracies or errors to the fullest extent permitted by law.',
  'Your use of any information or materials on our website and/or product pages is entirely at your own risk, for which we shall not be liable. It shall be your own responsibility to ensure that any products, services or information available through our website and/or product pages meet your specific requirements.',
  'Our website contains material which is owned by or licensed to us. This material includes, but are not limited to, the design, layout, look, appearance and graphics. Reproduction is prohibited other than in accordance with the copyright notice, which forms part of these terms and conditions.',
  'All trademarks reproduced in our website which are not the property of, or licensed to, the operator are acknowledged on the website.',
  'Unauthorized use of information provided by us shall give rise to a claim for damages and/or be a criminal offense.',
  'From time to time our website may also include links to other websites. These links are provided for your convenience to provide further information.',
  'You may not create a link to our website from another website or document without KASH PARALEGAL SERVICES PRIVATE LIMITED’s prior written consent.',
  'Any dispute arising out of use of our website and/or purchase with us and/or any engagement with us is subject to the laws of India.',
  'We, shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any Transaction, on Account of the Cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time.',
];

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-black text-white py-20 px-4" data-testid="terms-page">
      <div className="container mx-auto max-w-4xl">
        {/* Navigation */}
        <div className="mb-8">
          <Button
            variant="outline"
            onClick={() => (window.location.href = '/')}
            className="border-golden/20 text-golden hover:bg-golden hover:text-black transition-colors"
            data-testid="terms-back-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Home
          </Button>
        </div>

        {/* Header */}
        <div className="text-center mb-12">
          <Badge className="bg-golden/10 text-golden border-golden/20 mb-4">Legal</Badge>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-golden">Terms &amp; Conditions</h1>
          <p className="text-gray-400">Upper Circuit Stocks by Chirag Rathod</p>
        </div>

        <Card className="bg-gray-900/50 border-golden/20 mb-8">
          <CardHeader>
            <CardTitle className="text-golden">Overview</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4 text-gray-300 leading-relaxed">
            <p>
              For the purpose of these Terms and Conditions, the terms "we", "us", "our" used anywhere on this page
              shall mean <strong className="text-white">KASH PARALEGAL SERVICES PRIVATE LIMITED</strong>, whose
              registered/operational office is Flat No. 102, Nikki Apt, NSP Vasai, Palghar Nallosapare E Thane Vasai
              Maharashtra India 401209 Nallosapare E MAHARASHTRA 401209. "you", "your", "user", "visitor" shall mean
              any natural or legal person who is visiting our website and/or agreed to purchase from us.
            </p>
            <p>
              Your use of the website and/or purchase from us are governed by the following Terms and Conditions:
            </p>
          </CardContent>
        </Card>

        <Card className="bg-gray-900/50 border-golden/20 mb-8">
          <CardHeader>
            <CardTitle className="text-golden">Terms of Use</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="space-y-4">
              {TERMS.map((t, i) => (
                <li key={i} className="flex gap-3 text-gray-300 leading-relaxed" data-testid={`terms-item-${i}`}>
                  <span className="text-golden font-semibold shrink-0">{i + 1}.</span>
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>

        <Card className="bg-golden/5 border-golden/30">
          <CardHeader>
            <CardTitle className="text-golden">Company &amp; Contact</CardTitle>
          </CardHeader>
          <CardContent>
            <h4 className="font-semibold text-white mb-2">Registered / Operational Office</h4>
            <p className="text-gray-300">
              KASH PARALEGAL SERVICES PRIVATE LIMITED<br />
              Flat No. 102, Nikki Apt, NSP Vasai, Palghar<br />
              Nallosapare E, Thane, Vasai, Maharashtra, India 401209
            </p>
            <div className="mt-4">
              <h4 className="font-semibold text-white mb-2">Support</h4>
              <p className="text-gray-300">chiragbrathod1988@gmail.com</p>
            </div>
            <div className="mt-4 p-4 bg-black/30 rounded-lg">
              <p className="text-sm text-gray-400">
                <strong>Note:</strong> Any dispute arising out of use of our website and/or purchase with us is subject
                to the laws of India.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TermsAndConditions;
